import React, { FC } from 'react';
import Image from 'components/image/Image';
import { Children } from 'core/interface/popup';

import './Index.scss';
import useLocales from 'hooks/useLocales';

export const Popup: FC<
  Children & { showCloseButton?: boolean; closeOnOverlayClick?: boolean }
> = ({
  title,
  description,
  children,
  onClose,
  className,
  showCloseButton = true,
  closeOnOverlayClick = true
}): JSX.Element => {
  const { t } = useLocales();
  const onModalClose = (): void => {
    onClose();
  };

  return (
    <div className="popup">
      <div
        onClick={closeOnOverlayClick ? onModalClose : undefined}
        className="popup__content"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={`popup__content__main ${className ?? ''} scrollable`}
        >
          {showCloseButton && (
            <span className="popup__content__main-close" onClick={onModalClose}>
              <Image name="close.svg" width={22} height={22} />
            </span>
          )}
          <span
            className="popup__title"
            style={{ paddingBottom: description ? 0 : '20px' }}
          >
            {t(title) || title}
          </span>
          {description && (
            <p className="popup__desc">{t(description) || description}</p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Popup;
